
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5413',
  depVersions: {
  "data-privacy-request-ui": "static-1.5413",
  "data-fetching-client": "static-1.9564",
  "head-dlb": "static-1.4921",
  "history": "static-4.47",
  "hs-test-utils": "static-1.7900",
  "hub-http-shared-msw-handlers": "static-1.9704",
  "hubspot-dlb": "static-2.1828",
  "HubStyleTokens": "static-2-me-set-font-family-mixin.6",
  "I18n": "static-7.1598",
  "jasmine-runner": "static-1.6358",
  "privacy-center-public-service-types": "static-1.4676",
  "quartz": "static-1.6851",
  "react-dlb": "static-1.76",
  "react-router-dom": "static-5.26",
  "ui-components-test-utils": "static-1-me-set-font-family-mixin.6",
  "UIComponents": "static-3-me-set-font-family-mixin.6",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.84",
  "foundations-assets": "static-1.4733",
  "foundations-components": "static-1.7697",
  "foundations-components-test-utils": "static-1.5180",
  "foundations-theming": "static-1.4300",
  "hub-http": "static-1.6107",
  "quartz-config": "static-1.629",
  "quartz-core": "static-1.6070",
  "quick-fetch": "static-1.3822",
  "raven": "static-3.5808",
  "react": "static-7.184",
  "react-rhumb": "static-1.16542",
  "SharedI18nStrings": "static-1.181",
  "ui-addon-i18n": "static-1.11035",
  "usage-tracker": "static-1.7224",
  "usage-tracker-anonymous": "static-1.5641",
  "usage-tracker-core": "static-1.7074",
  "enviro": "static-4.425",
  "hs-promise-rejection-tracking": "static-1.5473",
  "PortalIdParser": "static-2.386",
  "raven-hubspot": "static-1.6115",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4034",
  "immutable": "static-2.76",
  "metrics-js": "static-1.9522",
  "react-redux": "static-7.69",
  "redux": "static-4.16",
  "styled-components": "static-2.87",
  "bend-plugin-trellis-migration": "static-1.3313",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3128",
  "quartz-webpack": "static-1.3075",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.80",
  "HeadJS": "static-2.732",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3011",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "ts-schema": "static-1.3986",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.81",
  "react-utils": "static-2.5255",
  "StyleGuideUI": "static-3.485",
  "jasmine": "static-4.4213",
  "rpc-client-utils": "static-1.4532",
  "HubStyle": "static-2-me-set-font-family-mixin.6",
  "ui-addon-draggable": "static-3.4658",
  "cssUtils": "static-1.764",
  "hs-story-utils": "static-1.9317",
  "icons": "static-2-me-set-font-family-mixin.2",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.97",
  "ui-images": "static-2-me-set-font-family-mixin.2",
  "bend-plugin-foundations-components": "static-1.3966",
  "floating-ui": "static-1.54",
  "foundations-theming-specialty": "static-1.2016",
  "react-aria": "static-1.64",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1487",
  "ui-fonts": "static-1-me-set-font-family-mixin.6",
  "foundations-components-legacy": "static-1.722",
  "bend-plugin-foundations-theming": "static-1.2783",
  "foundations-theming-base": "static-1.3285",
  "stylex": "static-1.30",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.816",
  "hubspotter-http": "static-1.4560",
  "mobile-manifest-mixins": "static-1.506",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.526",
  "quartz-head": "static-1.516",
  "quartz-i18n": "static-1.526",
  "quartz-routing": "static-1.281",
  "quartz-test": "static-1.526",
  "quartz-tracking": "static-1.230",
  "usage-tracker-container": "static-1.7214",
  "csstype": "static-1.50",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3056",
  "sassPrefix": "static-1.153",
  "chirp-fetch": "static-1.1770",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.68",
  "hubspotter-http-shared-msw-handlers": "static-1.9702",
  "usage-tracker-session-replay": "static-1.4910",
  "amplitude-session-replay-browser": "static-1.58"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5413",
  "data-fetching-client": "/data-fetching-client/static-1.9564",
  "head-dlb": "/head-dlb/static-1.4921",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.7900",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9704",
  "hubspot-dlb": "/hubspot-dlb/static-2.1828",
  "HubStyleTokens": "/HubStyleTokens/static-2-me-set-font-family-mixin.6",
  "I18n": "/I18n/static-7.1598",
  "jasmine-runner": "/jasmine-runner/static-1.6358",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4676",
  "quartz": "/quartz/static-1.6851",
  "react-dlb": "/react-dlb/static-1.76",
  "react-router-dom": "/react-router-dom/static-5.26",
  "ui-components-test-utils": "/ui-components-test-utils/static-1-me-set-font-family-mixin.6",
  "UIComponents": "/UIComponents/static-3-me-set-font-family-mixin.6",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "foundations-assets": "/foundations-assets/static-1.4733",
  "foundations-components": "/foundations-components/static-1.7697",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5180",
  "foundations-theming": "/foundations-theming/static-1.4300",
  "hub-http": "/hub-http/static-1.6107",
  "quartz-config": "/quartz-config/static-1.629",
  "quartz-core": "/quartz-core/static-1.6070",
  "quick-fetch": "/quick-fetch/static-1.3822",
  "raven": "/raven/static-3.5808",
  "react": "/react/static-7.184",
  "react-rhumb": "/react-rhumb/static-1.16542",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11035",
  "usage-tracker": "/usage-tracker/static-1.7224",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5641",
  "usage-tracker-core": "/usage-tracker-core/static-1.7074",
  "enviro": "/enviro/static-4.425",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5473",
  "PortalIdParser": "/PortalIdParser/static-2.386",
  "raven-hubspot": "/raven-hubspot/static-1.6115",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4034",
  "immutable": "/immutable/static-2.76",
  "metrics-js": "/metrics-js/static-1.9522",
  "react-redux": "/react-redux/static-7.69",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.87",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3313",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3128",
  "quartz-webpack": "/quartz-webpack/static-1.3075",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.80",
  "HeadJS": "/HeadJS/static-2.732",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3011",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "ts-schema": "/ts-schema/static-1.3986",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.81",
  "react-utils": "/react-utils/static-2.5255",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "jasmine": "/jasmine/static-4.4213",
  "rpc-client-utils": "/rpc-client-utils/static-1.4532",
  "HubStyle": "/HubStyle/static-2-me-set-font-family-mixin.6",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4658",
  "cssUtils": "/cssUtils/static-1.764",
  "hs-story-utils": "/hs-story-utils/static-1.9317",
  "icons": "/icons/static-2-me-set-font-family-mixin.2",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.97",
  "ui-images": "/ui-images/static-2-me-set-font-family-mixin.2",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3966",
  "floating-ui": "/floating-ui/static-1.54",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2016",
  "react-aria": "/react-aria/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1487",
  "ui-fonts": "/ui-fonts/static-1-me-set-font-family-mixin.6",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.722",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2783",
  "foundations-theming-base": "/foundations-theming-base/static-1.3285",
  "stylex": "/stylex/static-1.30",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.816",
  "hubspotter-http": "/hubspotter-http/static-1.4560",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.506",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.526",
  "quartz-head": "/quartz-head/static-1.516",
  "quartz-i18n": "/quartz-i18n/static-1.526",
  "quartz-routing": "/quartz-routing/static-1.281",
  "quartz-test": "/quartz-test/static-1.526",
  "quartz-tracking": "/quartz-tracking/static-1.230",
  "usage-tracker-container": "/usage-tracker-container/static-1.7214",
  "csstype": "/csstype/static-1.50",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3056",
  "sassPrefix": "/sassPrefix/static-1.153",
  "chirp-fetch": "/chirp-fetch/static-1.1770",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.68",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9702",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4910",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58"
}
};
